import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function Spinner({ label = "Memuat…" }) {
  return (
    <div data-testid="loading-spinner" className="min-h-[50vh] grid place-items-center text-slate-500">
      <div className="flex flex-col items-center gap-3">
        <span className="w-9 h-9 rounded-full border-4 border-blue-100 border-t-blue-600 animate-spin" />
        <span className="text-sm font-medium">{label}</span>
      </div>
    </div>
  );
}

export function Protected({ children, admin = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Spinner />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (admin && (user.role === "member" || !user.role)) return <Navigate to="/portal" replace />;
  return children;
}
